import React, { useEffect, useRef, useState } from "react";
import { Button } from "antd";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import styles from "./FloatingButton.module.css"; // Import the styles as a module
import { FiPlusCircle } from "react-icons/fi";
import TextComponent from "../textComponent/TextComponent";

const FloatingButton = ({
  Buttons,
  button_message,
  buttonStyles,
  floatStyle,
}) => {
  const [isVisible, setIsVisible] = useState(false); // Track visibility of extra buttons

  // Toggle visibility of additional buttons
  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const floatRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (floatRef.current && !floatRef.current.contains(e.target)) {
        setIsVisible(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div style={{ position: floatStyle ? "relative" : "" }}>
      {/* Main floating action button */}
      {/* <Button
        type="primary"
        shape="circle"
        icon={<PlusOutlined />}
        size="large"
        className={styles.floatingBtn} // Use styles from CSS module
        onClick={toggleVisibility}
      /> */}

      <div
        className={floatStyle || styles.floatingBtn}
        onClick={toggleVisibility}
        ref={floatRef}
      >
        {!isVisible ? (
          <FiPlusCircle size={18} style={{ marginRight: "5px" }} />
        ) : (
          <></>
        )}
        <TextComponent
          text={
            !isVisible
              ? button_message
                ? button_message
                : "Add New Vehicle"
              : "Close"
          }
        />
      </div>

      {/* Additional buttons */}
      {isVisible && (
        <div className={buttonStyles || styles.floatingButtonsContainer}>
          {Buttons?.map?.((item) => (
            <div
              className={styles.floatingBtnExtra}
              onClick={() => {
                item?.onClick?.();
                setIsVisible(false);
              }}
            >
              {/* <FiPlusCircle size={18} style={{ marginRight: "5px" }} /> */}
              <TextComponent text={item.title} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FloatingButton;
